import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box, IconButton } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { Card, FullScreenDialog } from '../../ui-kit';
import { useWarehousesScope } from '../warehouse/providers/WarehouseScopeProvider';
import { routePaths } from '../../routePaths';
import { DeductionListComponent } from '../../generated/graphql';
import { LocationReferrer } from '../../types/locationReferrer';
import { DeductionListDetailsSection, DeductionListTable } from './components';

const DeductionListDetails = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const history = useHistory<LocationReferrer>();
    const { params: { id: deductionListId } } = useRouteMatch();
    const { currentWarehouseId } = useWarehousesScope();
    const { state = {} } = history.location;
    const { referrer } = state;

    const onClose = () => {
        setIsDialogOpened(false);
        history.push(referrer || routePaths.warehouseDeductionLists);
    };

    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <Card style={{ height: '100%', overflow: 'auto' }}>
                <Box px={3} py={2}>
                    <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                        <ArrowBack />
                    </IconButton>
                    <Box mb={2} />
                    <DeductionListComponent variables={{ id: deductionListId, warehouseId: currentWarehouseId as string }}>
                        {({ data: { deductionList } }) => (
                            <>
                                <DeductionListDetailsSection deductionList={deductionList} />
                                <DeductionListTable />
                            </>
                        )}
                    </DeductionListComponent>
                </Box>
            </Card>
        </FullScreenDialog>
    );
};

export default DeductionListDetails;